export default __webpack_public_path__ + "static/media/darkpie.2ff67919.png";